import { create } from 'zustand';

interface CanvasAssetAssociationAttentionState {
  itemIds: Record<string, true>;
  localTagIds: Record<string, true>;
  markItems: (itemIds: string[]) => void;
  clearItem: (itemId: string) => void;
  hasItem: (itemId: string) => boolean;
  noteLocalTagChange: (tagId: string) => void;
  consumeLocalTagChange: (tagId: string) => boolean;
  reset: () => void;
}

const emptyRecord: Record<string, true> = {};

export const useCanvasAssetAssociationAttentionStore = create<CanvasAssetAssociationAttentionState>(
  (set, get) => ({
    itemIds: emptyRecord,
    localTagIds: emptyRecord,
    markItems: (itemIds) => {
      const uniqueIds = itemIds.map((itemId) => itemId.trim()).filter(Boolean);
      if (uniqueIds.length === 0) return;
      set((state) => {
        const next = { ...state.itemIds };
        for (const itemId of uniqueIds) next[itemId] = true;
        return { itemIds: next };
      });
    },
    clearItem: (itemId) => {
      const key = itemId.trim();
      if (!key) return;
      set((state) => {
        if (!state.itemIds[key]) return state;
        const next = { ...state.itemIds };
        delete next[key];
        return { itemIds: next };
      });
    },
    hasItem: (itemId) => Boolean(get().itemIds[itemId.trim()]),
    noteLocalTagChange: (tagId) => {
      const key = tagId.trim();
      if (!key) return;
      set((state) => ({
        localTagIds: { ...state.localTagIds, [key]: true },
      }));
    },
    consumeLocalTagChange: (tagId) => {
      const key = tagId.trim();
      if (!key || !get().localTagIds[key]) return false;
      set((state) => {
        const next = { ...state.localTagIds };
        delete next[key];
        return { localTagIds: next };
      });
      return true;
    },
    reset: () => set({ itemIds: emptyRecord, localTagIds: emptyRecord }),
  })
);
